import {
  Drawer as MuiDrawer,
  DrawerProps as MuiDrawerProps,
} from '@mui/material';

function Drawer(props: MuiDrawerProps) {
  return <MuiDrawer {...props} />;
}

export default Drawer;
